import * as React from 'react'

function SvgLife(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="48px" height="48px" viewBox="0 0 437.13 437" {...props}>
      <linearGradient
        id="plane_svg__a"
        gradientUnits="userSpaceOnUse"
        x1={218.498}
        x2={218.498}
        y1={-27.316}
        y2={475.357}
      >
        <stop offset={0} stopColor="#00efd1" />
        <stop offset={1} stopColor="#00acea" />
      </linearGradient>
      <path
        d="M345.781 15.828a4.157 4.157 0 00-.183.188L307.71 56.453 106.57 46.25a8.024 8.024 0 00-6.06 2.332l-45.59 45.59a8.01 8.01 0 00-2.1 7.621 8.006 8.006 0 005.472 5.707l157.59 46.969-64.414 68.754-117.047-8.04a7.97 7.97 0 00-6.2 2.325L2.345 243.383a8 8 0 002.386 12.96l75.344 33.739a130.961 130.961 0 0139.23 27.02l.204.199a131.023 131.023 0 0126.847 38.832l34.512 76.355a8.003 8.003 0 0012.945 2.363l25.872-25.867a7.993 7.993 0 002.324-6.207l-8.031-117.043 68.75-64.414 46.972 157.586a8 8 0 0013.324 3.375l45.59-45.597a8.018 8.018 0 002.332-6.063l-10.199-201.14 40.434-37.887c.066-.059.129-.117.187-.18A53.436 53.436 0 00435.32 39.73a53.446 53.446 0 00-37.855-37.855 53.436 53.436 0 00-51.684 13.953zM75.723 95.996l33.59-33.586 184.074 9.336-65.274 69.672zm299.062 231.887L341.2 361.469l-45.422-152.387 69.672-65.277zm35.356-247.871L173.324 301.89a7.996 7.996 0 00-.367 11.308 7.999 7.999 0 0011.305.367l14.648-13.718 6.89 100.39-15.116 15.117-29.743-65.812a147.015 147.015 0 00-30.101-43.54l-.2-.198a146.902 146.902 0 00-44.027-30.32l-64.742-29 15.086-15.09 100.39 6.89-13.718 14.645a8.004 8.004 0 00.367 11.308c3.227 3.02 8.29 2.856 11.309-.367L357.18 27.055c14.652-14.48 38.246-14.414 52.808.152 14.567 14.563 14.633 38.156.153 52.805zm0 0"
        fill="url(#plane_svg__a)"
      />
    </svg>
  )
}

export default SvgLife
